import { Button, Col, Form, Input, Modal, notification, Row } from 'antd';
import React, { useCallback, useEffect, useMemo } from 'react';
import styled from 'styled-components';

import { getAlphabet } from '../../library/util';
import { Class } from '../../models/Class';

const ButtonSave = styled(Button)`
  width: 100%;
`;

const ButtonCancel = styled(Button)`
  float: right;
`;

interface IProps {
  classes: Class[];
  submitting?: boolean;
  error: Error | null;
  onClose: () => void;
  onSubmit: (classification: Class) => void;
}

const ClassModal: React.FC<IProps> = ({
  classes,
  error,
  onClose,
  onSubmit,
  submitting,
}) => {
  const [form] = Form.useForm();

  const placeholder = useMemo(() => {
    return `Class ${getAlphabet(classes.length)}`;
  }, [classes]);

  const closeModal = useCallback(() => {
    form.resetFields();
    onClose();
  }, [form, onClose]);

  const submitModal = useCallback(
    (classification: Class) => {
      onSubmit(classification);
    },
    [onSubmit]
  );

  useEffect(() => {
    if (error) {
      notification.error({
        description: error.message,
        message: error.name,
      });
    }
  }, [error]);

  return (
    <Modal
      centered
      visible
      footer={null}
      maskClosable={false}
      title="Add Rate Class"
      width={400}
      onCancel={closeModal}
    >
      <Form form={form} layout="vertical" onFinish={submitModal}>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              label="Rate Class Name"
              name="name"
              rules={[{ message: 'Required', required: true }]}
            >
              <Input placeholder={placeholder} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item>
              <ButtonCancel onClick={closeModal}>Cancel</ButtonCancel>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              <ButtonSave htmlType="submit" loading={submitting} type="primary">
                SAVE
              </ButtonSave>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ClassModal;
